import React from 'react';

import { TransactionFilterContext } from 'src/context/transaction-filter-context';
import TransactionDateFilterCriteria from './transaction-date-filter-criteria/transaction-date-filter-criteria';

import './filter-criteria-row.scss';

export default function FilterCriteriaRow(props) {
  return (
    <div className={`FilterCriteriaRow scrollable-row ${props.className || ''}`} data-testid="FilterCriteriaRow">
      { props.filterCriteria && props.filterCriteria.map((filter, index) => (
        filter.value ?
          <div className="search-criteria-container" key={index} data-testid={`search-criteria-${index}`}>
            { filter.value }
            { filter.clear && 
              <span
                className="clear-search-criteria-icon is-icon-7 icon-cross is-clickable"
                onClick={filter.clear}
                data-testid={`search-criteria-${index}-clear`}
              ></span>
            }
          </div>
        : ''
      ))}
      { TransactionFilterContext && props.showDate &&
        <TransactionDateFilterCriteria />
      }
    </div>
  );
}